import { render, staticRenderFns } from "./slidePreview.vue?vue&type=template&id=f367fdca&scoped=true&"
import script from "./slidePreview.vue?vue&type=script&lang=js&"
export * from "./slidePreview.vue?vue&type=script&lang=js&"
import style0 from "./slidePreview.vue?vue&type=style&index=0&id=f367fdca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f367fdca",
  null
  
)

export default component.exports